import { States } from "@core/enums/state.enum";
import { Expose } from "class-transformer";
import { Attachment } from "@core/model/attachment";
export class Site {
    @Expose() id: string | undefined;
    @Expose() businessId: string | undefined;
    @Expose() siteNo: string | undefined;
    @Expose() siteName: string | undefined;
    @Expose() name: string | undefined;
    @Expose() state: States | undefined;
    @Expose() address1: string | undefined;
    @Expose() address2: string | undefined;
    @Expose() city: string | undefined;
    @Expose() siteState: string | undefined;
    @Expose() zip: string | undefined;
    @Expose() phone: string | undefined;
    @Expose() latitude: string | undefined;
    @Expose() longitude: string | undefined;
    @Expose() completeAddress: string | undefined;
    @Expose() parentId?: string;
    @Expose() parent: ParentSite | undefined;
    @Expose() siteManagerId?: string;
    @Expose() country?: string ;
    @Expose() timeZone?: string;
    @Expose() siteSetting?: string;
    @Expose() description?: string;
    @Expose() type: number;
    @Expose() areaSqFt?: number;
    @Expose() mapPlacemarkName?: string;
    @Expose() areaUnitId?: string;
    @Expose() unitLookup?: UnitLookup;
    @Expose() attachment: Attachment;
    @Expose() childSite: Site[] = [];
    child: ChildSite[]| undefined;
isExpand?:boolean;
loading?:boolean;
  }

  export class UnitLookup {
    @Expose() setting?: string;
    @Expose() code?: string;
    @Expose() name?: string;
}


  export class ChildSite {
    @Expose() id: string | undefined;
    @Expose() businessId: string | undefined;
    @Expose() siteNo: string | undefined;
    @Expose() siteName: string | undefined;
    @Expose() name: string | undefined;
    @Expose() state: States | undefined;
    @Expose() address1: number | undefined;
    @Expose() address2: string | undefined;
    @Expose() city: string | undefined;
    @Expose() siteState: string | undefined;
    @Expose() zip: string | undefined;
    @Expose() phone: string | undefined;
    @Expose() latitude: string | undefined;
    @Expose() longitude: string | undefined;
    @Expose() completeAddress: string | undefined;
    @Expose() parentId?: string ;
    @Expose() parent: ParentSite | undefined;
    @Expose() siteManagerId?: string;
isExpand?:boolean;
  }
  export class ParentSite {
    @Expose() siteNo: string | undefined;
    @Expose() siteName: string | undefined;
    @Expose() name: string | undefined;
    @Expose() address1: number | undefined;
    @Expose() address2: string | undefined;
    @Expose() city: string | undefined;
    @Expose() siteState: string | undefined;
    @Expose() zip: string | undefined;
    @Expose() phone: string | undefined;
    @Expose() unitLookup?: UnitLookup;
    @Expose() parent: ParentSite | undefined;
    @Expose() siteManagerId: string | undefined;
    @Expose() parentId?: string;
  }

  export class UpdateSite {
      @Expose() id: string;
      @Expose() businessId: string;
      @Expose() siteNo: string;
      @Expose() siteName: string;
      @Expose() state: States;
      @Expose() address1?: string;
      @Expose() address2?: string;
      @Expose() city?: string;
      @Expose() siteState?: string;
      @Expose() zip?: string;
      @Expose() phone?: string;
      @Expose() latitude?: string;
      @Expose() longitude?: string;
      @Expose() completeAddress?: string;
    @Expose() parentId?: string;
    @Expose() siteManagerId?: string;
    @Expose() country?: string;
    @Expose() timeZone?: string;
    @Expose() siteSetting?: string;
    @Expose() description?: string;
    @Expose() areaUnitId?: string;
    @Expose() type: number | undefined;
    @Expose() createdOn: Date | undefined;
    @Expose() createdById: string | undefined;
    @Expose() updatedOn: Date | undefined;
    @Expose() updatedById: string | undefined;
  }

  export class CreateSite  {
      @Expose() businessId: string;
      @Expose() siteNo: string;
      @Expose() siteName: string;
      @Expose() state?: States;
      @Expose() address1?: string;
      @Expose() address2?: string;
      @Expose() city?: string;
      @Expose() siteState?: string;
      @Expose() zip?: string;
      @Expose() phone?: string;
      @Expose() latitude?: string;
      @Expose() longitude?: string;
      @Expose() completeAddress?: string;
    @Expose() parentId?: string;
    @Expose() siteManagerId?: string;
    @Expose() country?: string;
    @Expose() timeZone?: string;
    @Expose() siteSetting?: string;
    @Expose() description?: string;
    @Expose() areaUnitId?: string;
    @Expose() type: number | undefined;
    @Expose() createdOn: Date | undefined;
    @Expose() createdById: string | undefined;
    @Expose() updatedOn: Date | undefined;
    @Expose() updatedById: string | undefined;

  }

  export class Data{
    id: string;
    parentId: string;
    title:string;
  }
